import React from 'react';
import { Edit, SaveButton, SimpleForm, Toolbar, TextInput, required } from 'react-admin';
import { CustomDateInput } from '../../../../commonComponents/CustomDateInput';
import { WordleLettersInput } from '../../../../commonComponents/WordleLettersInput';

const WordleEventsEditToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton />
  </Toolbar>
);

const WordleEventsEdit = (props) => (
  <Edit undoable={false} {...props}>
    <SimpleForm toolbar={<WordleEventsEditToolbar />}>
      <TextInput label="Id" source="id" disabled />
      <CustomDateInput label="Date" source="date" validate={required()} />
      <WordleLettersInput source="letters" label="Letters" validate={required()} />
    </SimpleForm>
  </Edit>
);

export default WordleEventsEdit;
